import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ClockIcon from "@mui/icons-material/WatchLater";
import styles from "./style";

const TrialIndicator = ({ daysLeft = null }) => {
  if (daysLeft === null || daysLeft === undefined || !daysLeft) {
    return null;
  }
  return (
    <Box sx={styles.trialIndicator}>
      <ClockIcon color="primary" style={{ width: 18, marginRight: 5 }} />
      <Typography variant="body1" color="primary">
        {daysLeft > 0
          ? `${daysLeft} days left in your free trial`
          : "Free trial will end today"}
      </Typography>
    </Box>
  );
};

export default TrialIndicator;
